module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-mobile-73021671243b5c1ebac4760301e6f3fa.jpg";